export const roadmap = {
    firstYear: [
        {
            title: "Phase 1: Organizing the structure of the future project and Hiring a team \n(Months 1-3)",
            top: true,
            points: [
                "Hiring technical and financial specialists",
                "Development of the concept of the first version",
                "Design and project and construction of the AI learning model",
                "Office rental and relocation of all specialists requiring relocation"
            ]
        },
        {
            title: "Phase 2: Initial AI Algorithm Development \n(Months 3-6)",
            top: false,
            points: [
                "Collecting, clean, and process large financial datasets with the help of finance experts.",
                "Developing the framework for AI models (without actual prediction generation)",
                "Finance experts guide the data features and market variables the AI will eventually predict",
            ]
        },
        {
            title: "Phase 3: Alpha Version Prototype & Internal System Testing \n(Months 6-9)",
            top: true,
            points: [
                "Creating a basic 'Alpha prototype' of the platform, focusing on backend and data flow (not user-ready yet).",
                "No real AI predictions yet; this step focuses on data accuracy, system stability, and backend workflows.",
                "Internal testing on basic financial calculations and system reliability, ensuring that AI has the correct data inputs.",
            ]
        },
        {
            title: "Phase 4: AI Model Prototyping & Alpha Refinement \n(Months 9-12) - parallel",
            top: false,
            points: [
                "AI engineers build 'early models' for stock prediction, but the outputs are still in testing and refinement stages.",
                "Finance experts validate that the initial model predictions align with real-world financial scenarios.",
                "Build initial design prototypes for the 'news list' and 'personalized analytics', though they will be non-functional at this stage.",
            ]
        },
        {
            title: "Phase 5: Application Development \n(Months 9-12) - parallel",
            top: true,
            points: [
                "Design UI/UX first version for beta-app functional is ready",
                "Data Base organisation, prepared first version of backend",
                "Application interface is developing (not user-ready yet).",
            ]
        }
    ],
    secondYear: [
        {
            title: "Phase 6: Beta Version Development \n(Months 12-15)",
            top: false,
            points: [
                "Alpha testing with focus groups of first functions",
                "Fixing issues and beginning building the 'Beta version' with basic stock forecasting features and personalized analytics.",
                "Expand AI capabilities based on Alpha results, but predictions are still early-stage."
            ]
        },
        {
            title: "Phase 7: External Beta Testing Preparation \n(Months 15-18)",
            top: true,
            points: [
                "Refining AI models based on feedback from finance experts and initial data.",
                "Preparation Beta version for external testing but (do not launch externally yet)",
                "Finalizing the Beta platform's structure: stock forecasts, personalized analytics, news integration, and trading instruments."
            ]
        },
        {
            title: "Phase 8: Limited External Beta Testing \n(Months 18-21)",
            top: false,
            points: [
                "Launch the Beta version for a 'select group' of external users (early testers).",
                "Collect feedback on platform performance, AI accuracy, and user engagement.",
                "Collaborate with finance experts to validate the accuracy of stock forecasts and ensure the platform is functioning correctly."
            ]
        },
        {
            title: "Phase 9: AI Scaling & Feature Expansion \n(Months 21-23)",
            top: true,
            points: [
                "Fine-tune personalized analytics based on external testing results.",
                "Expand trading instruments and refine the news feed integration.",
                "Continue to refine user interface and experience based on user feedback."
            ]
        },
        {
            title: "Phase 10: Beta Version Market Launch \n(Months 23-24)",
            top: false,
            points: [
                "Officially launch the 'Beta version' to a larger audience with:\n" +
                "    - Stock forecasts for the most famous stocks.\n" +
                "    - Personalized analytics and insights based on user preferences.\n" +
                "    - A news feed with relevant financial updates.\n" +
                "    - Trading instruments for executing trades directly on the platform.",
                "Beginning marketing push to acquire more users and promote the Beta version."
            ]
        }
    ],
    thirdYear: [
        {
            title: "Phase 11: Open Beta & Community Growth\n(Months 25–27)",
            top: true,
            points: [
                "Open access to the Beta version for the general public.",
                "Implement referral programs and community-building campaigns.",
                "Monitor early metrics like retention, engagement, and feature usage."
            ]
        },
        {
            title: "Phase 12: Monetization Launch & Feedback Loop\n(Months 27–29)",
            top: false,
            points: [
                "Introduce paid plans for B2C users (monthly/yearly tiers).",
                "Collect data on pricing sensitivity and user conversion.",
                "Launch feedback loop systems to continuously improve AI insights."
            ]
        },
        {
            title: "Phase 13: B2B Onboarding & Financial Partnerships\n(Months 29–31)",
            top: true,
            points: [
                "Initiate pilot partnerships with financial firms, banks, and fintechs.",
                "Provide B2B clients with dashboard access and advanced features.",
                "Set up legal and compliance infrastructure for larger deals."
            ]
        },
        {
            title: "Phase 14: Product Refinement & Infrastructure Scaling\n(Months 31–33)",
            top: false,
            points: [
                "Optimize backend systems for scalability and cost-efficiency.",
                "Refactor AI models for speed and accuracy under real-world loads.",
                "Add missing features based on user behavior analytics."
            ]
        },
        {
            title: "Phase 15: Break-Even Readiness & Market Expansion Prep\n(Months 33–36)",
            top: true,
            points: [
                "Align unit economics to approach break-even point.",
                "Prepare localization, legal documents, and marketing for US and Gulf region expansion.",
                "Develop investor reports and pitch decks for Series A funding."
            ]
        }
    ]
};


export const reports = [
    {
        title: "Report 1: Platform Foundation & Data Architecture (Months 6)",
        description: "Core platform infrastructure and data architecture are in place. Financial datasets have been collected, and the AI framework has been established. The system is ready for Alpha development."
    },
    {
        title: "Report 2: Alpha Version Prototype & AI Model Development (Months 12)",
        description: "The Alpha prototype is operational, focusing on system stability and financial data accuracy. Early AI models for stock forecasts are under development, with input from finance experts guiding model training."
    },
    {
        title: "Report 3: Beta Development & External Testing Preparation (Month 18)",
        description: "The Beta version is under development, featuring stock forecasts and personalized analytics. External Beta testing is being prepared, and the AI models are being refined based on initial internal feedback."
    },
    {
        title: "Report 4: External Beta Testing & AI Scaling (Month 22)",
        description: "Limited external Beta testing is underway, and AI models have been scaled for improved prediction accuracy. User feedback is being collected, and preparations for full market launch are progressing."
    },
    {
        title: "Report 5: Market-Ready Beta Version (Month 24)",
        description: "The Beta version is ready for market release."
    },
    {
        title: "Report 6: Monetization Launch & B2B Pilot Programs (Month 30)",
        description: "The platform has initiated monetization through paid subscription tiers. First B2B pilot integrations have begun with select financial partners. Initial revenue metrics and user conversion rates are under evaluation."
    },
    {
        title: "Report 7: Product Optimization & Scaling Infrastructure (Month 33)",
        description: "Ongoing refinement of AI models, user interface, and backend architecture is underway. Technical infrastructure has been scaled to support increased user load and data processing demands in preparation for market expansion."
    },
    {
        title: "Report 8: Break-Even Readiness & Expansion Strategy (Month 36)",
        description: "The platform is approaching break-even. Preparations for entering new markets (US, Gulf region) are finalized, including legal, compliance, and localization efforts. A Series A investment round is being prepared to fund expansion."
    }
];

export const team = [
    "AI/ML Engineers (6-7)",
    "Data Scientists (3-4)",
    "Finance Experts (2-3)",
    "Market Analysts (1-2)",
    "Frontend/Backend Developers (5-7)",
    "DevOps Engineers (2)",
    "QA Engineers (2-3)",
    "UI/UX Designers (2)",
    "Management (3-4)",
];
